import { Component, OnInit, Input } from "@angular/core";

@Component({
	selector: "feedback-bottom-text",
	templateUrl: "./feedback-bottom.html",
	styleUrls: ["./feedback-bottom.css"],
})
export class FeedbackBottomDirective {
	@Input() public feedbackText: string = "";
	@Input() public isCorrect: boolean;
	@Input() textDirection: string;

	constructor() {}
}
